<div class="modal-header">
    <h3 class="modal-title mb-0">{{data.uuid ? 'Edit Admin' : 'Add Admin'}}</h3>
</div>
<div class="modal-body">
    <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
        <div class="mb-3">
            <label for="name" class="form-label">Name <em>*</em></label>
            <input type="text" class="form-control" id="name" name="name" #name="ngModel" [(ngModel)]="data.name" required>
            <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                <div *ngIf="name.errors.required">Name is required</div>
            </div>
        </div>
        <div class="mb-3">
            <label for="mobile" class="form-label">Mobile <em>*</em></label>
            <input type="text" class="form-control" id="mobile" name="mobile" #mobile="ngModel" [(ngModel)]="data.mobile" required>
            <div *ngIf="f.submitted && mobile.invalid" class="invalid-feedback">
                <div *ngIf="mobile.errors.required">Mobile is required</div>
            </div>
        </div>
        <div class="mb-3">
            <label for="password" class="form-label">Password <em>*</em></label>
            <input type="password" class="form-control" id="password" name="password" #password="ngModel" [(ngModel)]="data.password" required>
            <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                <div *ngIf="password.errors.required">Password is required</div>
            </div>
        </div>
        <div class="mb-3"> <label for="status" class="form-label">Status <em>*</em></label>
            <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                <option [value]="1">Active</option>
                <option [value]="0">Disabled</option>
            </select>
            <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                <div *ngIf="status.errors.required">Status is required</div>
            </div>
        </div>
        <div class="mb-3" *ngIf="data.is_banker_admin"> 
            <label for="status" class="form-label">Super Admin <em>*</em></label>
            <select class="form-control" name="is_banker_super_admin" #is_banker_super_admin="ngModel" [(ngModel)]="data.is_banker_super_admin" required>
                <option [value]="1">Yes</option>
                <option [value]="0">No</option>
            </select>
            <div *ngIf="f.submitted && is_banker_super_admin.invalid" class="invalid-feedback">
                <div *ngIf="is_banker_super_admin.errors.required">Super Admin is required</div>
            </div>
        </div>
        <div class="d-flex justify-content-between">   
            <button type="button" class="btn btn-secondary" (click)="closeEvent.emit(false)">Cancel</button>
            <button type="submit" class="btn btn-primary">{{data.uuid ? 'Update' : 'Create'}} Admin</button>
        </div>
    </form>
</div>